import {GamesListComponent} from "./pages/games-list/games-list.component";

export const gamesRoutes =  [
  {path: '', redirectTo: 'list', pathMatch: 'full'},
  {path: 'list', component: GamesListComponent, pathMatch: 'full'},
];
